import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTPInterceptorService } from './services/http-interceptor.service';
import { LoginComponent } from './components/auth/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { SignupComponent } from './components/auth/signup/signup.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { ToastrModule } from 'ngx-toastr';
import { WppsiViewComponent } from './components/wppsi/wppsi-view/wppsi-view.component';
import { WppsiVisualSpatialIndexComponent } from './components/wppsi/wppsi-visual-spatial-index/wppsi-visual-spatial-index.component';
import { WppsiProcessingSpeedIndexComponent } from './components/wppsi/wppsi-processing-speed-index/wppsi-processing-speed-index.component';
import { DccsViewComponent } from './components/dccs/dccs-view/dccs-view.component';
import { DccsPreComponent } from './components/dccs/dccs-pre/dccs-pre.component';
import { DccsPostComponent } from './components/dccs/dccs-post/dccs-post.component';
import { DccsBorderComponent } from './components/dccs/dccs-border/dccs-border.component';
import { StroopViewComponent } from './components/stroop/stroop-view/stroop-view.component';
import { StroopCongruentComponent } from './components/stroop/stroop-congruent/stroop-congruent.component';
import { StroopIncongruentComponent } from './components/stroop/stroop-incongruent/stroop-incongruent.component';
import { CantabViewComponent } from './components/cantab/cantab-view/cantab-view.component';
import { FinishComponent } from './components/finish/finish.component';
import { CompleteComponent } from './components/complete/complete.component';
import { CantabPlayComponent } from './components/cantab/cantab-play/cantab-play.component';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        HomeComponent,
        SignupComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        NavbarComponent,
        AvatarComponent,
        WppsiViewComponent,
        WppsiVisualSpatialIndexComponent,
        WppsiProcessingSpeedIndexComponent,
        DccsViewComponent,
        DccsPreComponent,
        DccsPostComponent,
        DccsBorderComponent,
        StroopViewComponent,
        StroopCongruentComponent,
        StroopIncongruentComponent,
        CantabViewComponent,
        FinishComponent,
        CompleteComponent,
        CantabPlayComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot()
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HTTPInterceptorService,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
